<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Companies List" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->
<div class="row">
    <div class="col-xxl-9">
        <div class="card">
            <div class="card-body">
                <div class="row g-3">
                    <div class="col-xxl-5 col-sm-6">
                        <div class="search-box">
                            <input type="text" class="form-control search bg-light border-light" id="searchCompany" placeholder="Search for company, industry type..." [(ngModel)]="searchTerm" (ngModelChange)="performSearch()">
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xxl-3 col-sm-6">
                        <input type="text" class="form-control bg-light border-light" id="datepicker" mwlFlatpickr [convertModelValue]="true" data-date-format="d M, Y" placeholder="Select date" [(ngModel)]="date">
                    </div>
                    <!--end col-->
                    <div class="col-xxl-2 col-sm-4">
                        <div class="input-light">
                            <select class="form-control" data-choices data-choices-search-false name="choices-single-default" id="idType">
                                <option value="" selected>All</option>
                                <option value="Full Time">Full Time</option>
                                <option value="Part Time">Part Time</option>
                                <option value="Internship">Internship</option>
                                <option value="Freelance">Freelance</option>
                            </select>
                        </div>
                    </div>
                    <!--end col-->

                    <div class="col-xxl-2 col-sm-4">
                        <button type="button" class="btn btn-success w-100" onclick="filterData();">
                            <i class="ri-equalizer-fill mx-1 align-bottom"></i> Filters
                        </button>
                    </div>
                    <!--end col-->
                </div>
                <!--end row-->
            </div>
        </div>

        <div class="row job-list-row" id="companies-list">
            @for ( data of companies; track $index) {
            <div class="col-xxl-3 col-md-6">
                <div class="card companiesList-card">
                    <div class="card-body">
                        <div class="avatar-sm mx-auto">
                            <div class="avatar-title bg-light rounded"> <img src="{{data.image_src}}" alt="" class="avatar-xxs companyLogo-img"> </div>
                        </div>
                        <div class="text-center"> <a href="javascript:void(0);">
                                <h5 class="mt-3 company-name">{{data.name}}</h5>
                            </a>
                            <div class="d-none company-desc">{{data.company_info}}</div>
                            <p class="text-muted industry-type">{{data.industry_type}}</p>
                            <div class="d-none"> <span class="employee">{{data.employee}}</span>
                                <span class="location">{{data.location}}</span> <span class="rating">{{data.rating}}</span>
                                <span class="website">{{data.website}}</span>
                                <span class="email">{{data.email}}</span>
                                <span class="since">{{data.since}}</span>
                            </div>
                        </div>
                        <div> <button type="button" class="btn btn-soft-primary w-100 viewcompany-list" (click)="companydetail($index)"><span class="vacancy">{{data.vacancy}}</span> Jobs
                                Available</button> </div>
                    </div>
                </div>
            </div>
            }
        </div>

        <!-- pagination -->
        @if(jobdetail){
        <ngb-pagination class="d-flex justify-content-end pt-2" [collectionSize]="allcompanies.length" [(page)]="service.page" [pageSize]="service.pageSize" (pageChange)="changePage()" aria-label="Custom pagination">
            <ng-template ngbPaginationPrevious let-page let-pages="pages">
                <i class="ci-arrow-left me-2"></i>
                Prev
            </ng-template>
            <ng-template ngbPaginationNext>
                Next
                <i class="ci-arrow-right ms-2"></i>
            </ng-template>
        </ngb-pagination>
        }
    </div>
    @if(jobdetail){
    <div class="col-xxl-3">
        <div class="card" id="company-overview">
            <div class="card-body">
                <div class="avatar-lg mx-auto mb-3">
                    <div class="avatar-title bg-light rounded">
                        <img src="{{jobdetail.image_src}}" alt="" class="avatar-sm company-logo">
                    </div>
                </div>

                <div class="text-center">
                    <a href="javascript:void(0);">
                        <h5 class="overview-companyname">{{jobdetail.name}}</h5>
                    </a>
                    <p class="text-muted overview-industryType">{{jobdetail.industry_type}}</p>

                    <ul class="list-inline mb-0">
                        <li class="list-inline-item avatar-xs">
                            <a href="javascript:void(0);" class="avatar-title bg-success-subtle text-success fs-15 rounded">
                                <i class="ri-global-line"></i>
                            </a>
                        </li>
                        <li class="list-inline-item avatar-xs">
                            <a href="javascript:void(0);" class="avatar-title bg-danger-subtle text-danger fs-15 rounded">
                                <i class="ri-mail-line"></i>
                            </a>
                        </li>
                        <li class="list-inline-item avatar-xs">
                            <a href="javascript:void(0);" class="avatar-title bg-warning-subtle text-warning fs-15 rounded">
                                <i class="ri-question-answer-line"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="card-body">
                <h6 class="text-muted text-uppercase fw-semibold mb-3">Information</h6>
                <p class="text-muted mb-4 overview-companydesc">{{jobdetail.company_info}}</p>

                <div class="table-responsive table-card">
                    <table class="table table-borderless mb-4">
                        <tbody>
                            <tr>
                                <td class="fw-medium" scope="row">Industry Type</td>
                                <td class="overview-industryType">{{jobdetail.industry_type}}</td>
                            </tr>
                            <tr>
                                <td class="fw-medium" scope="row">Location</td>
                                <td class="overview-company_location">{{jobdetail.location}}</td>
                            </tr>
                            <tr>
                                <td class="fw-medium" scope="row">Employee</td>
                                <td class="overview-employee">{{jobdetail.employee}}</td>
                            </tr>
                            <tr>
                                <td class="fw-medium" scope="row">Vacancy</td>
                                <td class="overview-vacancy">{{jobdetail.vacancy}}</td>
                            </tr>
                            <tr>
                                <td class="fw-medium" scope="row">Rating</td>
                                <td><span class="overview-rating">{{jobdetail.rating}}</span> <i class="ri-star-fill text-warning align-bottom"></i></td>
                            </tr>
                            <tr>
                                <td class="fw-medium" scope="row">Website</td>
                                <td>
                                    <a href="javascript:void(0);" class="link-primary text-decoration-underline overview-website">{{jobdetail.website}}</a>
                                </td>
                            </tr>
                            <tr>
                                <td class="fw-medium" scope="row">Contact Email</td>
                                <td class="overview-email">{{jobdetail.email}}</td>
                            </tr>
                            <tr>
                                <td class="fw-medium" scope="row">Since</td>
                                <td class="overview-since">{{jobdetail.since}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="hstack gap-3">
                    <button type="button" class="btn btn-soft-success custom-toggle w-100" id="togglefollow" (click)="followClick($event)">
                        <span class="icon-on">
                            <i class="me-1" [ngClass]="(followbtn == '1')?'ri-add-line align-bottom':'ri-user-unfollow-line align-bottom'"></i>
                            {{followtxt}}</span>
                    </button>
                    <a href="javascript:void(0);" class="btn btn-primary w-100">More View <i class="ri-arrow-right-line align-bottom"></i></a>
                </div>
            </div>
        </div>

        <div class="card overflow-hidden shadow-none">
            <div class="card-body bg-danger-subtle">
                <div class="d-flex align-items-center">
                    <div class="flex-shrink-0">
                        <div class="avatar-sm">
                            <div class="avatar-title bg-danger-subtle text-danger rounded-circle fs-17">
                                <i class="ri-gift-line"></i>
                            </div>
                        </div>
                    </div>
                    <div class="flex-grow-1 ms-2">
                        <h6 class="fs-16">Free trial</h6>
                        <p class="text-muted mb-0">28 days left</p>
                    </div>
                    <div>
                        <a routerLink="/pages/pricing" class="btn btn-danger">Upgrade</a>
                    </div>
                </div>
            </div>
            <div class="card-body bg-danger-subtle border-top border-danger border-opacity-25 border-top-dashed">
                <a href="javascript:void(0);" class="d-flex justify-content-between align-items-center text-body">
                    <span>See benefits</span>
                    <i class="ri-arrow-right-s-line fs-18"></i>
                </a>
            </div>
        </div>
    </div>
    }
    <div id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>